import axios from 'axios';

const API_URL = process.env.REACT_APP_API_BASE_URL;

export const sendContactMessage = async (contactData) => {
    try {
        const response = await axios.post(`${API_URL}/api/contact-message`, contactData);
        return response.data;
    } catch (error) {
        // Handle different types of errors
        if (error.response) {
            // Server responded with error status
            const errorMessage = error.response.data?.message || `Server error: ${error.response.status}`;
            throw new Error(errorMessage);
        } else if (error.request) {
            // Network error
            throw new Error('Network error. Please check your connection and try again.');
        } else {
            // Other error
            throw new Error('An unexpected error occurred. Please try again.');
        }
    }
};
